<template>
  <div>
    <v-card class="pa-10 pb-8" max-width="420" :elevation="24">
      <Logo
        :url="getCouncilImage"
        alt="Logo Benfeitores"
        height="65"
        width="185"
      />
      <h4 class="mt-12 primary--text">Login</h4>
      <p class="mt-2">Por favor entre com seus dados para prosseguir:</p>
      <v-row>
        <v-form v-model="isUsernameAndPasswordValid">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="username"
                  label="E-mail"
                  name="email"
                  outlined
                  hide-details
                  required
                  :rules="[validateUsername]"
                  :disabled="loading"
                  autocomplete="email"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="password"
                  label="Senha"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  :rules="[rules.rulePassword]"
                  :type="showPassword ? 'text' : 'password'"
                  name="password"
                  outlined
                  value
                  @click:append="showPassword = !showPassword"
                  hide-details
                  required
                  :disabled="loading"
                  autocomplete="current-password"
                ></v-text-field>
                <p class="text-right mb-0 mt-1">
                  <a
                    class="forgot-password"
                    v-on:click="$emit('forgot-password')"
                    >Esqueceu a senha?</a
                  >
                </p>
              </v-col>
              <v-layout justify-center>
                <vue-recaptcha
                  class="mt-4 mx-auto recaptcha"
                  sitekey="6LeWfeYUAAAAAKxjNm8yMikwkekatb0WAy4WoAdV"
                  @verify="captchaVerified"
                ></vue-recaptcha>
              </v-layout>
            </v-row>
          </v-container>
        </v-form>
        <v-col cols="12">
          <v-btn
            :loading="loading"
            rounded
            depressed
            x-large
            block
            color="primary"
            @click="login()"
            :disabled="!isUsernameAndPasswordValid"
            >Entrar</v-btn
          >
          <p class="mt-3 mb-0 text-center">
            Não possui conta?
            <a class="text-center primary--text signup" @click="register()"
              >Cadastre-se!</a
            >
          </p>
        </v-col>
      </v-row>
    </v-card>

    <!--    botao de login-->
    <v-container style="max-width: 480px;" v-if="isCouncilLogin">
      <v-row>
        <v-col cols="12" class="text-center">
          <h6 text large rounded color="primary">
            Para doações em nome da sua Pessoa Física, <u role="button" @click="$emit('showLogin')" class="primary--text" style="font-size: 18px;">clique aqui!</u>
          </h6>
        </v-col>
      </v-row>
    </v-container>

    <template>
      <v-dialog
        v-model="showInvalidUsernameAndPasswordMessage"
        persistent
        max-width="490"
      >
        <v-card>
          <v-card-title>
            <h5 class="pt-5 pb-7 red--text">
              Usuário e senha inválidos.
            </h5>
          </v-card-title>
          <v-card-text>Usuário e senha inválidos.</v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="px-6 py-5">
            <v-spacer></v-spacer>
            <v-btn
              color="gray"
              rounded
              large
              depressed
              class="px-12"
              @click="showInvalidUsernameAndPasswordMessage = false"
              >Ok</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Agent Register Modal Dialog -->
    <template>
      <v-dialog
        v-model="showAgentRegisterDialog"
        scrollable
        persistent
        max-width="490"
      >
        <v-card>
          <v-card-title>
            <h5 class="pt-5">Cadastre-se</h5>
          </v-card-title>
          <v-card-text>
            <v-form ref="newAgentForm" v-model="isAgentInformationValid">
              <v-row>
                <v-col>
                  <v-subheader>dados básicos</v-subheader>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-mask="['###.###.###-##']"
                    v-model="agentDocument"
                    label="CPF"
                    outlined
                    hide-details="auto"
                    required
                    :rules="[validateNewAgentDocument]"
                    :disabled="savingNewAgent"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="agentFullName"
                    label="Nome"
                    outlined
                    hide-details="auto"
                    required
                    :rules="[validateNewAgentFullName]"
                    :disabled="savingNewAgent"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="agentPhone"
                    v-mask="['(##) #####-####', '(##) ####-####']"
                    label="Celular"
                    outlined
                    hide-details="auto"
                    required
                    :rules="[validateNewAgentPhone]"
                    :disabled="savingNewAgent"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="agentEmail"
                    label="E-mail"
                    outlined
                    hide-details="auto"
                    required
                    :rules="[validateNewAgentEmail]"
                    :disabled="savingNewAgent"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="agentPassword"
                    label="Senha"
                    :append-icon="showRegisterCardPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    :rules="[rules.rulePassword]"
                    :type="showRegisterCardPassword ? 'text' : 'password'"
                    name="password"
                    outlined
                    value                    
                    @click:append="showRegisterCardPassword = !showRegisterCardPassword"
                    hide-details
                    loading                    
                    required
                    :disabled="loading"
                  >
                    <template v-slot:progress>
                      <v-progress-linear
                        :value="progress"
                        :color="color"
                        absolute
                        height="7"
                        class="mt-1"
                      ></v-progress-linear>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :append-icon="showRegisterCardPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="showRegisterCardPassword ? 'text' : 'password'"
                    label="Confirme a senha"
                    @click:append="showRegisterCardPassword = !showRegisterCardPassword"
                    outlined
                    v-model="valueConfPassword"
                    hide-details="auto"
                    :rules="[agentPassword == valueConfPassword]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-subheader>endereço</v-subheader>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-mask="'#####-###'"
                    v-model="agentPostalCode"
                    label="CEP"
                    outlined
                    hide-details="auto"
                    required
                    :rules="[validateNewAgentPostalCode]"
                    :disabled="savingNewAgent"
                    @blur="getAddressByCEP"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="agentStreet"
                    label="Logradouro"
                    outlined
                    hide-details="auto"
                    required
                    :rules="[validateNewAgentStreet]"
                    :disabled="savingNewAgent"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="agentNumber"
                    type="number"
                    label="Número"
                    outlined
                    hide-details="auto"
                    required
                    :rules="[validateNewAgentNumber]"
                    :disabled="savingNewAgent"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="agentComplement"
                    label="Complemento"
                    outlined
                    hide-details="auto"
                    :disabled="savingNewAgent"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="agentNeighborhood"
                    label="Bairro"
                    outlined
                    hide-details="auto"
                    required
                    :rules="[validateNewAgentNeighborhood]"
                    :disabled="savingNewAgent"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="agentCity"
                    label="Cidade"
                    outlined
                    hide-details="auto"
                    required
                    :rules="[validateNewAgentCity]"
                    :disabled="savingNewAgent"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-combobox
                    v-model="agentState"
                    :items="stateList"
                    item-text="shortName"
                    label="Estado"
                    outlined
                    hide-details="auto"
                    required
                    :rules="[validateNewAgentState]"
                    :disabled="savingNewAgent"
                  ></v-combobox>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider class="lg"></v-divider>
          <v-card-actions class="px-6 py-5">
            <v-skeleton-loader
              :boilerplate="false"
              type="button"
              :tile="false"
              class="mx-auto"
              v-show="savingNewAgent"
            ></v-skeleton-loader>
            <v-btn
              rounded
              large
              depressed
              outlined
              class="px-12 gray"
              @click="closeAgentRegisterDialog()"
              v-show="!savingNewAgent"
              >Voltar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              rounded
              large
              depressed
              class="px-12"
              :disabled="!isAgentInformationValid"
              @click="saveNewAgent()"
              v-show="!savingNewAgent"
              >Cadastrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>


    <!-- Copyright -->
    <div class="copyright mt-5" v-if="!isAgent">
      Copyright ©2020 - Benfeitores®.
      <br />Todos os direitos reservados
    </div>
    <template>
      <v-dialog
        v-model="showInvalidUsernameAndPasswordMessage"
        persistent
        max-width="490"
      >
        <v-card>
          <v-card-title>
            <h5 class="pt-5 pb-7 red--text">
              Usuário e senha inválidos.
            </h5>
          </v-card-title>
          <v-card-text
            >Por favor, verifique os dados informados. Você deve informar seu
            e-mail cadastrado e a senha correspondente do seu
            cadastro.</v-card-text
          >
          <v-card-actions class="px-6 py-5">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              depressed
              large
              @click="showInvalidUsernameAndPasswordMessage = false"
              >Ok, entendi!</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Dialog with sucess message -->
    <template>
      <v-dialog
        v-model="showCreateAgentSucessMessage"
        persistent
        max-width="490"
      >
        <v-card>
          <v-card-title>
            <h5 class="pt-5 pb-7">Sucesso!</h5>
          </v-card-title>
          <v-card-text
            >Cadastro concluído com sucesso! Uma mensagem com a confirmação foi
            enviado para seu e-mail!</v-card-text
          >
          <v-card-actions class="px-6 py-5">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              depressed
              large
              @click="redirectToNewDonation()"
              >Ok, entendi!</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <!-- End of Dialog with sucess message -->

    <!-- Dialog with fail message -->
    <template>
      <v-dialog v-model="showCreateAgentFailMessage" persistent max-width="490">
        <v-card>
          <v-card-title>
            <h5 class="pt-5 pb-7">Deu Erro</h5>
          </v-card-title>
          <v-card-text
            >Ops! Deu erro, infelizmente tivemos problemas ao cadastrar, entre
            em contato com nosso suporte</v-card-text
          >
          <v-card-actions class="px-6 py-5">
            <v-spacer></v-spacer>
            <v-btn
              color="gray"
              text
              depressed
              large
              @click="clearNewAgentData()"
              >Entendi</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <!-- End of Dialog with sucess message -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Logo from "@/components/Logo";
import AuthService from "@/scripts/services/auth.service";
import Routes from "@/router/names.js";
import CommonHelper from "@/scripts/helpers/common.helper";
import VueRecaptcha from "vue-recaptcha";
import GeneralService from "@/scripts/services/general.service";
import cep from 'cep-promise';

export default {
  props: {
    isAgent: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  name: "LoginCard",
  components: {
    Logo,
    VueRecaptcha
  },
  data: () => ({
    loading: false,
    username: "",
    password: "",
    isUsernameAndPasswordValid: false,
    routes: Routes,
    showPassword: false,
    showRegisterCardPassword: false,
    showInvalidUsernameAndPasswordMessage: false,
    showAgentRegisterDialog: false,
    rules: {
      required: value => !!value || "Required.",
      rulePassword: v =>
        v.length >= 8 || "Sua senha deve ter mais que 8 caracters"
    },
    authService: new AuthService(),
    generalService: new GeneralService(),

    //Register Agent Information
    isAgentInformationValid: false,
    agentDocument: "",
    agentFullName: "",
    agentPhone: "",
    agentEmail: "",
    agentPassword: "",
    valueConfPassword: "",
    agentGoogleAddress: "",
    agentPostalCode: "",
    agentStreet: "",
    agentNumber: "",
    agentComplement: "",
    agentNeighborhood: "",
    agentCity: "",
    agentState: "",
    stateList: [],
    showCreateAgentFailMessage: false,
    savingNewAgent: false,
    showCreateAgentSucessMessage: false, 
    isCouncilLogin: false
  }),
  computed: {
    ...mapGetters(["getCouncilImage", "getCouncilId"]),
    progress() {     
      return this.ProgressBar();      
    },
    color() {
      return ["error", "warning", "success"][Math.floor(this.progress / 40)];
    }
  },
  created() {
    this.generalService
      .listAllStates()
      .then(result => (this.stateList = result));
      
      this.isCouncilLogin = this.getCouncilId != null
  },
  methods: {
    ...mapActions("userModule", ["setPermissions", "setIsAgent", "setLoggedEntityId"]),
    getAddressByCEP() {
      cep(this.agentPostalCode).then((response) => {
        this.agentStreet = response.street;
        this.agentNeighborhood = response.neighborhood;
        this.agentCity = response.city;
        this.agentState = response.state;
      });
    },
    ProgressBar(){
      if(!this.agentPassword){
        this.agentPassword = "";
      }
      return Math.min(100, this.agentPassword.length * 12.5);
    },
    validateUsername() {
      this.username = this.username.trim();
      if (this.username && CommonHelper.validateEmail(this.username))
        return true;
      return "Digite o seu email";
    },
    login() {
      this.loading = true;
      if (this.isAgent) {
        this.authService
          .loginAgent(this.username, this.password)
          .then(this.loginAgentCallback)
          .catch(this.loginCatch)
          .finally(() => (this.loading = false));
      } else {
        this.authService
          .login(this.username, this.password)
          .then(this.loginCallback)
          .catch(this.loginCatch)
          .finally(() => (this.loading = false));
      }
    },
    loginCallback(result) {
      this.setIsAgent(false);

      localStorage.removeItem("name");
      localStorage.removeItem("email");

      if(result.permissions.length > 1) {
        this.$router.push({ name: Routes.web.ChooseEntity, params: { entities: result.permissions } });
      } else {
        this.setLoggedEntityId(result.permissions[0].entityViewModel.id);
        this.setPermissions(result.permissions);
        this.$router.push({ name: Routes.app.Dashboard });
      }
    },
    loginAgentCallback() {
      this.setIsAgent(true);
      localStorage.removeItem("name");
      localStorage.removeItem("email");
      this.$router.push({ name: Routes.web.Start });
    },
    loginCatch() {
      this.showInvalidUsernameAndPasswordMessage = true;
    },
    register() {
      if (this.isAgent) {
        this.showAgentRegisterDialog = true;
      }
    },
    closeAgentRegisterDialog() {
      this.showAgentRegisterDialog = false;      
      this.clearNewAgentData();
    },
    clearNewAgentData() {
      this.showCreateAgentFailMessage = false;
      this.showAgentRegisterDialog = false;
      (this.agentDocument = ""),
        (this.agentFullName = ""),
        (this.agentPhone = ""),
        (this.agentEmail = ""),
        (this.agentPassword = ""),
        (this.valueConfPassword = ""),
        (this.agentGoogleAddress = ""),
        (this.agentPostalCode = ""),
        (this.agentStreet = ""),
        (this.agentNumber = ""),
        (this.agentComplement = ""),
        (this.agentNeighborhood = ""),
        (this.agentCity = ""),
        (this.agentState = ""),
        (this.isAgentInformationValid = false);
      if (this.$refs.newAgentForm) this.$refs.newAgentForm.reset();
    },
    saveNewAgent() {
      let newAgent = {
        email: this.agentEmail,
        password: this.agentPassword,
        personViewModel: {
          document: this.agentDocument,
          fullName: this.agentFullName,
          phone: this.agentPhone,
          isCompany: false,
          email: this.agentEmail,
          addressViewModel: {
            postalCode: this.agentPostalCode,
            state: this.agentState,
            city: this.agentCity,
            street: this.agentStreet,
            number: this.agentNumber,
            complement: this.agentComplement,
            neighborhood: this.agentNeighborhood,
            googleAddress: this.agentGoogleAddress
          }
        }
      };
      this.savingNewAgent = true;
      this.showSaveNewAgentConfirmationMessage = false;
      this.authService
        .createAgent(newAgent)
        .then(this.createAgentCallback)
        .catch(this.createAgentCatch);
    },
    createAgentCallback() {
      this.showCreateAgentSucessMessage = true;
    },
    createAgentCatch() {
      this.showCreateAgentFailMessage = true;
    },
    redirectToNewDonation() {
      this.loading = true;
      this.authService
        .loginAgent(this.agentEmail, this.agentPassword)
        .then(this.loginAgentCallback)
        .catch(this.loginCatch)
        .finally(() => (this.loading = false));
    },
    placechanged(formattedPlace) {
      this.agentPostalCode = formattedPlace.postalCode || "";
      this.agentStreet = formattedPlace.street || "";
      this.agentNumber = formattedPlace.number || "";
      this.agentNeighborhood = formattedPlace.neighborhood || "";
      this.agentCity = formattedPlace.city || "";
      this.agentState = formattedPlace.state || "";
    },
    validateNewAgentDocument() {
      if (!this.agentDocument) return "Preencha o documento";
      if (!CommonHelper.validateCPF(this.agentDocument)) return "CPF inválido";
      return true;
    },
    validateNewAgentFullName() {
      if (!this.agentFullName) 
        return "Preencha o nome";

      if(CommonHelper.wordCount(this.agentFullName) < 2)
        return "Informe seu Nome completo";

      return true;
    },
    validateNewAgentPhone() {
      if (!this.agentPhone) return "Preencha o celular";
      if(!CommonHelper.validateCellPhone(this.agentPhone))
        return "Celular Inválido";
      return true;
    },
    validateNewAgentEmail() {
      this.agentEmail = this.agentEmail.trim();
      
      if (!this.agentEmail) return "Preencha o e-mail";
      if (!CommonHelper.validateEmail(this.agentEmail))
        return "E-mail inválido";
      return true;
    },
    validateNewAgentGoogleAddress() {
      if (!this.agentGoogleAddress) return "Preencha o endereço";
      return true;
    },
    validateNewAgentPostalCode() {
      if (!this.agentPostalCode) return "Preencha o CEP";
      return true;
    },
    validateNewAgentStreet() {
      if (!this.agentStreet) return "Preencha o logradouro";
      return true;
    },
    validateNewAgentNumber() {
      if (!this.agentNumber) return "Preencha o número";
      return true;
    },
    validateNewAgentNeighborhood() {
      if (!this.agentNeighborhood) return "Preencha o bairro";
      return true;
    },
    validateNewAgentCity() {
      if (!this.agentCity) return "Preencha a cidade";
      return true;
    },
    validateNewAgentState() {
      if (!this.agentState) return "Preencha o estado";
      return true;
    },
    captchaVerified(result) {
      return result;
    }
  }
};
</script>

<style scoped>
.forgot-password {
  color: #273166;
  opacity: 0.5;
}
.copyright {
  color: #6c7293;
  font-size: 12px;
  text-align: center;
}
.signup {
  font-size: 120%;
}
</style>
